import { FC } from "react";
import { Box, Switch } from "@mui/material";

export const MappingSwitch: FC<{
  checked: boolean;
  disabled?: boolean;
  onChange: () => void;
}> = ({ checked, disabled, onChange }) => {
  return (
    <Switch
      color="secondary"
      checked={checked}
      disabled={disabled}
      onChange={onChange}
    />
  );
};

export const StatusPill: FC<{ status: string }> = ({ status }) => {
  const active = status == "ACTIVE";
  return (
    <Box sx={active ? sxActivePill : sxInactivePill}>
      {active ? "Active" : "Inactive"}
    </Box>
  );
};

const sxActivePill = {
  color: "success.dark",
  backgroundColor: "success.light",
  borderRadius: 0.75,
  px: 1,
  py: 0.25,
  fontSize: "0.75rem",
};

const sxInactivePill = {
  color: "text.secondary",
  backgroundColor: "custom.main",
  borderRadius: 0.75,
  px: 1,
  py: 0.25,
  fontSize: "0.75rem",
};
